import type { ReactNode } from "react";

export default function PriceSuffix({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  if (!children) {
    return null;
  }

  return <span className={className}>{children}</span>;
}

PriceSuffix.displayName = "PriceSuffix";
